module.exports = __webpack_public_path__ + "static/media/caros-light.92036ca5.woff2";